/* eslint-disable no-use-before-define */
import React from 'react';
import PropTypes from 'prop-types';
import PersonalizedCard from './personalized-card-list';
import LinkList from './link-list';
import { BodyText, Gutter } from '@gaiads/telia-react-component-library';
import { getChannelPackagesLinkText } from './personalized-card-utils';

const PersonalizedCardIptv = ({
  title,
  address,
  username,
  channelPackages,
  manageUrl,
  strings,
  ...props
}) => {
  const getLinks = () => {
    const manageLink = { text: strings.manageSubscription, url: manageUrl };
    const channelPackagesLink = { text: getChannelPackagesLinkText(strings.channelPackages, channelPackages), url: strings.channelPackagesUrl };
    const troubleshootLink = { text: strings.troubleshoot, url: strings.troubleshootUrl };

    return [manageLink, channelPackagesLink, troubleshootLink];
  };

  return (
    <PersonalizedCard title={title} {...props}>
      {address && (
        <BodyText block margin={{ bottom: 'xxs' }}>
          {address}
        </BodyText>
      )}

      {username && (
        <BodyText block margin={{ bottom: 'xxs' }}>
          {strings.username} {username}
        </BodyText>
      )}

      <Gutter size="xs" />

      <LinkList links={getLinks()} />
    </PersonalizedCard>
  );
};

PersonalizedCardIptv.defaultProps = {
  title: '',
  address: '',
  username: '',
  channelPackages: [],
  manageUrl: '',
  strings: {},
};

export const PersonalizedCardIptvShape = {
  title: PropTypes.string,
  address: PropTypes.string,
  username: PropTypes.string,
  channelPackages: PropTypes.arrayOf(PropTypes.string),
  manageUrl: PropTypes.string,
  strings: PropTypes.shape(PersonalizedCardIptvStringsShape).isRequired,
};

export const PersonalizedCardIptvStringsShape = {
  subscriptionNumber: PropTypes.string,
  channelPackages: PropTypes.string,
  channelPackagesUrl: PropTypes.string,
  manageSubscription: PropTypes.string,
  troubleshoot: PropTypes.string,
  troubleshootUrl: PropTypes.string,
};

PersonalizedCardIptv.propTypes = PersonalizedCardIptvShape;

export default PersonalizedCardIptv;
